// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getScreenGroups ( ) {

    const endPoint = `${basePath}/get-of06screengroups`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getScreenDetails ( group ) {

    const endPoint = `${basePath}/get-of06screendetails`;
    const payLoad = {
        group
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function addScreenDetails ( payload ) {

    const endPoint = `${basePath}/add-groupelement`;

    const options = {
        body: JSON.stringify( payload ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );

    }

}

export async function deleteScreenDetails ( payload ) {

    const endPoint = `${basePath}/delete-groupelement`;

    const options = {
        body: JSON.stringify( payload ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );

    }

}
